module.exports = __webpack_public_path__ + "img/3.ee6c957a.png";